import { useTranslation } from 'react-i18next';

import { SectionLayout } from '@/components/atoms/SectionLayout/SectionLayout';
import { Brain } from '@/shared/types/brain';

import { ModelStrategySection } from '../ModelStrategy/ModelStrategySection';

interface ModelFieldsetProps {
  brain: Brain;
}

export const ModelFieldset = ({ brain }: ModelFieldsetProps) => {
  const { t } = useTranslation();

  return (
    <div id="model-strategy">
      <SectionLayout title={t('ai_agents.model_strategy.title')}>
        <div className="relative rounded-lg border border-border bg-background p-6 pb-7">
          <ModelStrategySection
            key={brain.brain_id}
            brainId={brain.brain_id}
            legacyLanguageModelId={brain.language_model_id}
          />
        </div>
      </SectionLayout>
    </div>
  );
};
